<template>
  <div class="form-recipients-type-page">
    <app-page-header title="Editar">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'form-recipients.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <form-recipients-type-table
        :type="recipientsType"
      ></form-recipients-type-table>
    </app-card>
  </div>
</template>

<script>
import FormRecipientsTypeTable from '@/components/Tables/FormRecipientsTypeTable.vue';

export default {
  name: 'form-recipients-type-page',
  components: {
    FormRecipientsTypeTable,
  },
  data: () => {
    return {
      recipientsType: null,
    };
  },
  beforeMount() {
    this.recipientsType = this.$route.params.type;
  },
};
</script>

<style lang="sass" scoped></style>
